import React from 'react'

import Search from '../../../react4xp/components/Search'

function SearchResultsPart({ heading, pagination, strings, startValues }) {
    return (
        <Search
            heading={heading}
            pagination={pagination}
            strings={strings}
            startValues={startValues}
            hideBottomDivider={true}
        />
    )
}

export default (props) => <SearchResultsPart {...props} />
